function initializePricing(): void {
  const page = document.querySelector<HTMLElement>('[data-pricing-page]')
  if (!page) return

  page.querySelectorAll<HTMLButtonElement>('[data-pricing-dialog]').forEach((button) => {
    button.addEventListener('click', () => {
      const dialog = page.querySelector<HTMLDialogElement>(`[data-pricing-modal="${button.dataset.pricingDialog}"]`)!
      dialog.showModal()
    })
  })

  page.querySelectorAll<HTMLDialogElement>('[data-pricing-modal]').forEach((dialog) => {
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return
      const bounds = dialog.getBoundingClientRect()
      if (
        event.clientX < bounds.left ||
        event.clientX > bounds.right ||
        event.clientY < bounds.top ||
        event.clientY > bounds.bottom
      )
        dialog.close()
    })
  })
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializePricing)
else initializePricing()
